import { ProfileAntispywareAndDns } from 'src/dtos/version.dto';
import { Zone } from 'src/utils/enums';
export class EditableRule {
    id?: string;
    isDefault = false;
    name = '';
    active = true;
    position?: number;
    description = '';
    action?: 'allow' | 'drop';
    applicationsType = MultiSelectType.ANY;
    applications: string[] = [];
    servicesType = MultiSelectType.ANY;
    services: string[] = [];

    srcZone?: Zone;
    srcAddressGroupsType = MultiSelectType.ANY;
    srcAddressGroups: string[] = [];
    srcEdls: string[] = [];
    srcRegionsType = MultiSelectType.ANY;
    srcRegions: string[] = [];

    dstZone?: Zone;
    dstAddressGroupsType = MultiSelectType.ANY;
    dstAddressGroups: string[] = [];
    dstEdls: string[] = [];
    dstRegionsType = MultiSelectType.ANY;
    dstRegions: string[] = [];

    urlFiltering = 'Inactive';
    antiVirus?: string = 'Inactive';
    antiSpyware?: string = 'Inactive';
    vulnerabilityProtection?: string = 'Inactive';
    dns?: string = 'Inactive';
    profiles?: ProfileAntispywareAndDns[] = [];
}

export enum MultiSelectType {
    ANY = 'Any',
    SELECTED = 'Selected'
}